// inputs.js
import { validateRequired,validateLength, validateURL,validateNonZeroInteger,validateImageRequired,validateNotNull}from "../../../../helpers/validationsForm";

const Inputs = [
   {
     id: 1,
     label: "Descripción",
     name: "descripcion",
     type: "text",
     placeholder: "Ingrese la descripción",
     validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
   },
   {
     id: 5,
     label: "Imagen",
     name: "imagen",
     type: "file",
     placeholder: "Ingrese la descripción de la imagen",
     validation: (value, file) => {
           // Validación requerida
           const requiredError = validateImageRequired(value,file);
           if (requiredError) {
             return requiredError;
           }
     
           // Si no hay errores
           return null;
         }
   },
   {
     id: 4,
     label: "URL",
     name: "url",
     type: "text",
     title: "Por favor, ingrese una URL válida. Ejemplo: https://example.com",
         validation: (value, form) => {
          // Validación de correo
           const urlError = validateURL(value);
           if (urlError) {
             return urlError;
           }
           // Si no hay errores
           return null;
         }
   },
   {
     id: 3,
     label: "Target",
     name: "target",
     type: "select",
     options: [
       { value: 'true', label: 'Misma Página' },
       { value: 'false', label: 'Nueva Página' },
     ],
     placeholder: "Abrir en una...",
   },
   {
     id: 6,
     label: "Cantidad de columnas que ocupa",
     name: "columnas_estilo",
     type: "select",
     options: [
       { value: 1, label: '1 Columna' },
       { value: 2, label: '2 Columnas' },
       { value: 3, label: '3 Columnas' },
       { value: 4, label: '4 Columnas' },
     ],
     placeholder: "Ingrese el número de columnas",
        validation: (value, form) => {
           // Validación requerida
           const requiredError = validateNotNull(value);
           if (requiredError) {
             return requiredError;
           }
     
           // Validación de longitud
           const lengthError = validateNonZeroInteger(value);
           if (lengthError) {
             return lengthError;
           }
     
           // Si no hay errores
           return null;
         }
   },
   {
     id: 2,
     label: "Orden",
     name: "orden",
     type: "select",
     options: [
       { value: 1, label: 'Primera Celda' },
       { value: 2, label: 'Segunda Celda' },
       { value: 3, label: 'Tercera Celda' },
       { value: 4, label: 'Cuarta Celda' },
     ],
     placeholder: "Orden de Aparición",
        validation: (value, form) => {
           // Validación requerida
           const requiredError = validateNotNull(value);
           if (requiredError) {
             return requiredError;
           }
     
           // Validación de longitud
           const lengthError = validateNonZeroInteger(value);
           if (lengthError) {
             return lengthError;
           }
     
           // Si no hay errores
           return null;
         }
   },

];

export default Inputs;
